<i class="dialog-close fas fa-times" (click)="useGettingStartedTemplates(false)"></i>

<div class="dialog-content-container">
  <h1 transloco="startingTemplates.dialogTitle">Design Made Simple</h1>
  <p class="modal-summary" transloco="startingTemplates.dialogDescription">
    No more blank slates! Our starter templates are designed to guide you in building a stunning high-impact portfolio.
  </p>
  <img class="" [src]="dialogAsset" alt="Included" />
  <p class="modal-summary" transloco="startingTemplates.dialogFooter"> Templates can be customized or deleted. </p>
  <p class="modal-summary" transloco="startingTemplates.dialogFooter2"> Start creating now! </p>
</div>

<div class="dialog-footer-container">
  <aero-button
    class="dialog-footer-buttons"
    [aeroStyle]="cancelStyle"
    [size]="buttonSize"
    (onClick)="useGettingStartedTemplates(false)"
    labelCode="button_skip">
  </aero-button>
  <aero-button
    class="dialog-footer-buttons"
    [aeroStyle]="confirmStyle"
    [size]="buttonSize"
    (onClick)="useGettingStartedTemplates(true)"
    labelCode="copy_page">
  </aero-button>
</div>
